import React, { useRef, useState, useEffect } from 'react';
import { t } from 'i18next';
import "./../ThankyouPage.scss";
import useFindHeight from '../../../../Hooks/useFindHeight';



export function DeliveryDetails(props) {

    const { slotData, recipients, isRenewal } = props;
    const [recipientList, setRecipientList] = useState([]);
    const [observedDiv, elementHeight] = useFindHeight();
    const [shouldScroll, setShouldScroll] = useState(false);
    const [showDeliverySection, setShowDeliverySection] = useState(false);
    const [slotList, setSlotList] = useState([]);

    //for corporate renewals
    const emptySlotObject = {
        id: null,
        name: "",
        communicationId: null,
        email: "",
        Address: null
    };


    useEffect(() => {

        if (isRenewal && (slotData?.length > 0) && elementHeight > 310 && !shouldScroll) {
            setShouldScroll(true);
        }

    }, [slotData, isRenewal, elementHeight, shouldScroll]);


    const getUniqueRecipients = (recipients) => {

        return recipients?.filter((recipient, index, self) =>
            index === self.findIndex(r => r.id === recipient.id)
        );

    }

    const checkToShowDeliverySection = (recipients) => {

        const uniqueRecipients = getUniqueRecipients(recipients);

        let showSection = uniqueRecipients?.some(reci => reci.id !== props?.purchaser?.id || (reci?.Address?.address1?.length > 0 || reci?.Address?.address2?.length > 0 || reci?.Address?.address3?.length > 0))
        setShowDeliverySection(showSection);

    }

    const getSlotList = (slotData, recipients) => {

        const { numberOfSlots = 0, filledSlots = 0 } = slotData[0] || 0;

        const unfilledSlots = Math.max(0, numberOfSlots - filledSlots);

        const finalSlotList = Array.from({ length: (recipients?.length + unfilledSlots) }, (_, index) => {
            return recipients[index] || { ...emptySlotObject };

        });

        setSlotList(finalSlotList);

    }

    useEffect(() => {

        if (recipients?.length > 0) {

            checkToShowDeliverySection(recipients);

            if (slotData?.length > 0 && isRenewal) {

                //for corporate renewal
                getSlotList(slotData, recipients);

            } else {

                setRecipientList(recipients);
            }
        }

    }, [recipients]);


    const getUiForDeliveryRecipient = () => {

       return <>{ recipientList && recipientList?.map((recipientDetails, index) => (
                <>
                    <div className="item-container">
                        <div className="item-wrapper">

                            {recipientDetails?.id !== props?.purchaser?.id &&
                                <>
                                    <div class="item-field">{recipientDetails?.name}</div>
                                    <div class="item-field">{recipientDetails?.email}</div>

                                </>
                            }

                            {((recipientDetails?.Address?.address1?.length > 0 || recipientDetails?.Address?.address2?.length > 0 || recipientDetails?.Address?.address3?.length > 0)) &&

                                <div className="item-field">
                                    <p><strong>{t("thankyoupage.deliveryaddress")}</strong></p>
                                    <p>{recipientDetails.Address?.companyName}{recipientDetails.Address.companyName && ', '}
                                        {recipientDetails.Address?.address1}{recipientDetails.Address.address1 && ', '}
                                        {recipientDetails.Address?.address2}{recipientDetails.Address.address2 && ', '}
                                        {recipientDetails.Address?.address3}{recipientDetails.Address.address3 && ', '}
                                        {recipientDetails.Address?.town}{recipientDetails.Address.town && ', '}
                                        {recipientDetails.Address?.county}{recipientDetails.Address.county && ', '}
                                        {recipientDetails.Address?.country}{recipientDetails.Address.country && ', '}
                                        {recipientDetails.Address?.postcode}  </p>
                                </div>
                            }

                        </div>
                    </div>
                </>
            ))
        }
        </>
    }

    const getUiForSlotList = () => {

      return <div ref={observedDiv} className={`item-wrapper ${shouldScroll && "deliveryDetails-customScrollerHeight customScroll"}`} >

            {slotList && slotList?.map((seatDetails, index) => (
                <>
                    <div className="item-container">
                        <div className="item-wrapper">

                           <strong> {t("thankyoupage.recipientlabel")} {index + 1}</strong> 

                           {seatDetails?.name ?
                                <>
                                    <div class="item-field">{seatDetails?.name}</div>
                                    <div class="item-field">{seatDetails?.email}</div>

                                    {(seatDetails?.Address?.address1?.length > 0 ||
                                        seatDetails?.Address?.address2?.length > 0 ||
                                        seatDetails?.Address?.address3?.length > 0) && (

                                            <div className="item-field">
                                                <p><strong>{t("thankyoupage.deliveryaddress")}</strong></p>
                                                <p>
                                                    {seatDetails.Address?.companyName}
                                                    {seatDetails.Address?.companyName && ', '}

                                                    {seatDetails.Address?.address1}
                                                    {seatDetails.Address?.address1 && ', '}

                                                    {seatDetails.Address?.address2}
                                                    {seatDetails.Address?.address2 && ', '}

                                                    {seatDetails.Address?.address3}
                                                    {seatDetails.Address?.address3 && ', '}

                                                    {seatDetails.Address?.town}
                                                    {seatDetails.Address?.town && ', '}

                                                    {seatDetails.Address?.county}
                                                    {seatDetails.Address?.county && ', '}

                                                    {seatDetails.Address?.country}
                                                    {seatDetails.Address?.country && ', '}

                                                    {seatDetails.Address?.postcode}
                                                </p>
                                            </div>
                                        )}

                                </>
                                :
                                <div class="item-field">{t("thankyoupage.emptyslot")}</div>
                            }
                        </div>
                    </div>
                </>
            ))}
        </div>

    }


    const Delivery = () => {

        return <>
          
            <div className="item-wrapper">
                <h4>{t("thankyoupage.deliverydetails")}</h4>
            </div>

            {(isRenewal && (slotData?.length > 0)) ?  getUiForSlotList()  : getUiForDeliveryRecipient()}

        </>
 }
    return (<>
        {showDeliverySection &&
            <div className="details-block">
                <div className="item-container">
                    {Delivery()}
                </div> 
            </div>
        }
    </>)

}
